import { render, staticRenderFns } from "./grid-sub-form-item.vue?vue&type=template&id=f2a5a8ae&scoped=true&"
import script from "./grid-sub-form-item.vue?vue&type=script&lang=js&"
export * from "./grid-sub-form-item.vue?vue&type=script&lang=js&"
import style0 from "./grid-sub-form-item.vue?vue&type=style&index=0&id=f2a5a8ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a5a8ae",
  null
  
)

export default component.exports